import { graphql } from "react-apollo"
import { connect } from "react-redux"
import gql from "graphql-tag"
import Header from "."

const HeaderWithApollo = graphql(
  gql`
    query HeaderWithDefaultEntity {
      user {
        id
        umbrellaEntity {
          ... on ComplianceEntity {
            id
            name
            __typename
          }
        }
      }
    }
  `,
  {
    props: ({ data: { error, loading, user } }) => {
      if (error) {
        throw error
      }
      if (!loading) {
        return {
          entityType: user.umbrellaEntity.__typename.toLowerCase(),
          entityId: user.umbrellaEntity.id,
          entityName: user.umbrellaEntity.name,
          defaultEntity: true,
        }
      }
    },
  }
)(Header)

const HeaderWithDefaultEntity = connect(({ router }) => ({
  location: router.location,
}))(HeaderWithApollo)

export default HeaderWithDefaultEntity
